module.exports = __webpack_public_path__ + "static/media/image1.9afe7a82.png";